import { render } from "./App.vue?vue&type=template&id=a6fb5318"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a6fb5318&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-flechten_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__